import { css } from 'styled-components'

const primaryButtonTemplate = () => css`
  background: var(--primary);
  color: var(--white);

  &:hover {
    background: color-mix(in srgb, var(--primary) 80%, black);
  }

  &:focus-visible {
    box-shadow:
      0rem 0rem 0rem 0.0625rem var(--sl-color-gray-0),
      0rem 0rem 0rem 0.1875rem
        color-mix(in srgb, var(--primary) 40%, transparent);
  }

  &.active {
    background: color-mix(in srgb, var(--primary) 70%, black);
  }

  &:disabled {
    background: var(--sl-bg-base-strong-disabled);
  }
`

export default primaryButtonTemplate
